"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Buttons = _interopRequireDefault(require("../Buttons"));

var _Button = _interopRequireDefault(require("../Button"));

var _DropDownButton = _interopRequireDefault(require("../DropDownButton"));

var _Menu = _interopRequireWildcard(require("../Menu"));

var _arrowPrev = _interopRequireDefault(require("../icons/arrow-prev.svg"));

var _arrowNext = _interopRequireDefault(require("../icons/arrow-next.svg"));

var _config = require("../config/config");

require("./pager.sass");

var perPageRows = [15, 50, 100, 200];

var Pager =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Pager, _PureComponent);

  function Pager() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Pager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Pager)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handlePrevPage", function () {
      var perPage = _this.props.perPage || 1;
      var offset = _this.props.start - perPage;
      offset >= 0 && _this.handlePageChange(offset);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleNextPage", function () {
      var _this$props = _this.props,
          start = _this$props.start,
          perPage = _this$props.perPage,
          total = _this$props.total;
      var offset = start + (perPage || 1);
      offset < total && _this.handlePageChange(offset);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPerPage", function (perPage) {
      _this.props.onPerPageChange && _this.props.onPerPageChange(perPage);

      _this.handlePageChange(0); // set first page

    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "bindings", {
      right: _this.handleNextPage,
      left: _this.handlePrevPage
    });
    return _this;
  }

  (0, _createClass2.default)(Pager, [{
    key: "handlePageChange",
    value: function handlePageChange(current) {
      this.props.onPageChange && this.props.onPageChange(current);
    }
  }, {
    key: "getTotalLabel",
    value: function getTotalLabel() {
      var total = this.props.total;

      if (!total) {
        return '';
      }

      if (total === Infinity) {
        return '100000+';
      }

      return (0, _config.__)('of %s', total);
    }
  }, {
    key: "renderPosition",
    value: function renderPosition() {
      var _this2 = this;

      var _this$props2 = this.props,
          perPage = _this$props2.perPage,
          total = _this$props2.total,
          start = _this$props2.start,
          onPerPageChange = _this$props2.onPerPageChange;
      var to = perPage > 1 ? Math.min(total, start + perPage) : null;
      var label = [start + 1, to ? ' — ' + to : '', this.getTotalLabel()].join(' ');

      if (!onPerPageChange) {
        return _react.default.createElement("div", {
          className: "pager-text"
        }, label);
      }

      return _react.default.createElement(_DropDownButton.default, {
        borderless: true,
        noUpcase: true,
        label: label
      }, _react.default.createElement(_Menu.default, null, perPageRows.map(function (count) {
        return _react.default.createElement(_Menu.MenuItem, {
          key: count,
          onClick: function onClick() {
            return _this2.setPerPage(count);
          },
          className: count === perPage ? 'pager-perPage pager-perPage--selected' : 'pager-perPage'
        }, count);
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          perPage = _this$props3.perPage,
          total = _this$props3.total,
          start = _this$props3.start,
          disabled = _this$props3.disabled;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('pager', className)
      }, this.renderPosition(), _react.default.createElement(_Buttons.default, null, _react.default.createElement(_Button.default, {
        className: "pager-prev",
        shortcut: "left",
        onClick: this.handlePrevPage,
        disabled: disabled || start <= 0,
        Icon: _arrowPrev.default
      }), _react.default.createElement(_Button.default, {
        className: "pager-next",
        shortcut: "right",
        onClick: this.handleNextPage,
        disabled: disabled || start + perPage >= total,
        Icon: _arrowNext.default
      })));
    }
  }]);
  return Pager;
}(_react.PureComponent);

exports.default = Pager;
Pager.propTypes = process.env.NODE_ENV !== "production" ? {
  onPageChange: _propTypes.default.func.isRequired,
  onPerPageChange: _propTypes.default.func,
  total: _propTypes.default.number,
  perPage: _propTypes.default.number,
  start: _propTypes.default.number,
  disabled: _propTypes.default.bool
} : {};